import { Component, OnInit } from '@angular/core'
import { CurrentUser } from '../../../common/models/current-user'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { UserProfile } from '../../models/user-profile'
import { Router } from '@angular/router'

@Component({
    selector: 'UserSearch',
    templateUrl: 'user-search.component.html'
})
export class UserSearchComponent implements OnInit {
    public userName: string
    public loading: boolean = true
    error: boolean = false
    invalidAgent: boolean = false
    currentUser: CurrentUser = {} as CurrentUser
    constructor(private _currentUserGateway: CurrentUserGateway, private _userProfileGateway: UserProfileGateway, private router: Router) {}
    ngOnInit(): void {
        this._currentUserGateway.getCurrentUser().subscribe((user: CurrentUser) => {
            this.currentUser = user
            this.loading = false
        })
    }

    searchAgent() {
        this.invalidAgent = false
        this.error = false
        if (this.userName != undefined && this.userName != null && this.userName.trim() != '' && this.currentUser != null) {
            this.loading = true
            this._userProfileGateway.userProfileSearch(this.userName, Number(this.currentUser.userProfileId)).subscribe((model: UserProfile) => {
                if (model == null || model.UserProfileID == 0) {
                    this.invalidAgent = true
                    this.error = false
                    this.loading = false
                } else {
                    this.loading = false
                    this.router.navigate([
                        '/' + this.currentUser.insuranceCompanyShortName.toLowerCase() + '/user-management/user-search/' + model.UserProfileID
                    ])
                }
            })
        } else {
            this.error = true
            this.invalidAgent = false
        }
    }

    selectedValueChange = (event) => {
        this.invalidAgent = false
        this.error = false
        this.userName = event
    }

    onFindKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.searchAgent()
        }
    }
}
